/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Chunk_DescriptionInputs */



/**
* | output |
* | --- |
* | "The page needs to reload to load the latest version. Your unsaved changes may be lost." |
*
* @param {Error_Chunk_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const error_chunk_description = /** @type {((inputs?: Error_Chunk_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Chunk_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Seite muss neu geladen werden, um die neueste Version zu laden. Ungespeicherte Änderungen können verloren gehen.")
	return /** @type {LocalizedString} */ ("The page needs to reload to load the latest version. Your unsaved changes may be lost.")
});